
import { Component, Vue, Prop } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import rules from "@/store/rules";

@Component
export default class EditCancellationRequest extends Vue {
	@Prop()
	private orderId!: number;
	private request: any = {};
	private isLoading: boolean = false;
	private formValid: boolean = true;
	private requiredNonNegativeNumberRule = rules.requiredNonNegativeNumberRule;

	private async mounted() {
		if (!this.requestIsLoaded) {
			await this.loadRequest();
		}
		this.request = this.$store.state.orderCancellations.filter(
			(c: any) => c.blexonOrderId == this.orderId
		)[0];
	}

	private get requestIsLoaded() {
		return (
			this.$store.state.orderCancellations !== null &&
			this.$store.state.orderCancellations.length > 0 &&
			this.$store.state.orderCancellations.filter(
				(c: any) => c.blexonOrderId == this.orderId
			)[0].blexonOrderId == this.orderId
		);
	}

	private get cancellationSettingsAreValid() {
		return (
			!this.isLoading &&
			this.request != null &&
			this.request.positions != null &&
			this.formValid
		);
	}

	private get subTotal() {
		let positionCost = this.request.positions.reduce(
			(acc: number, pos: any) => acc + pos.cancellationCost,
			0
		);
		return this.request.fixCosts + parseFloat(positionCost);
	}

	private async loadRequest() {
		try {
			this.isLoading = true;
			const response = await httpClient().post(
				"CustomerOrder/GetOrderCancellationRequestsByOrderIds",
				[this.orderId]
			);
			this.$store.commit("addOrUpdateOrderCancellations", response.data);
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Stornierung konnte nicht geladen werden.");
		} finally {
			this.isLoading = false;
		}
	}

	private async saveCost() {
		if (!this.cancellationSettingsAreValid) return false;
		console.log("saving cost...");
		try {
			this.isLoading = true;
			await httpClient().post(`CustomerOrder/UpdateCancellationCost`, this.request);

			// Update state
			this.$store.commit("addOrUpdateOrderCancellations", [this.request]);
			this.$store.commit("setSnackbarText", "Kosten wurden angepasst.");
			this.goToOrders();
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Kosten konnten nicht gespeichert werden.");
		} finally {
			this.isLoading = false;
		}
	}

	private getThumbnailUrl(articleId: number) {
		return process.env.VUE_APP_erpUrl + `article/getthumbnail?id=${articleId}`;
	}

	private goToOrders() {
		this.$router.push({ name: "order" });
	}

	private getProcessStepText(stepValue: number) {
		switch (stepValue) {
			case 0:
				return "Nicht gestartet";
			case 1:
				return "Programmiert";
			case 2:
				return "Geschnitten";
			case 3:
				return "Entgratet";
			case 4:
				return "Abgekantet";
			case 5:
				return "Beschichtet";
		}
	}

	private getRequestStateText(stateValue: number) {
		switch (stateValue) {
			case 0:
				return "Kosten ermitteln";
			case 1:
				return "Warten auf Kundenentscheidung";
			case 2:
				return "Akzeptiert";
			case 3:
				return "Abgelehnt";
		}
	}
}
